import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-99ecc340"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "introduction"
}, [/*#__PURE__*/_createElementVNode("ol", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("li", null, " Choose the type of Amazon account to connect and select its region. "), /*#__PURE__*/_createElementVNode("li", null, " Select a country where this account operates and click Authorize. "), /*#__PURE__*/_createElementVNode("li", null, " Sign in to Amazon and select the account to connect from the list. ")])], -1));
const _hoisted_2 = {
  style: {
    "padding": "20px 24px"
  }
};
const _hoisted_3 = {
  class: "check-option"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type of account", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group");
  const _component_app_select = _resolveComponent("app-select");
  const _component_app_form = _resolveComponent("app-form");
  const _component_custom_side_bar_app_modal = _resolveComponent("custom-side-bar-app-modal");
  return _openBlock(), _createBlock(_component_custom_side_bar_app_modal, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.modal = $event),
    title: `Add Amazon account`,
    okTitle: "Authorize",
    onOk: $options.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_app_form, {
      novalidate: "",
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [_createVNode(_component_b_form_radio_group, {
        class: "checkbox",
        modelValue: $data.form.account_provider,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.account_provider = $event),
        options: $data.accountTypeOptions
      }, null, 8, ["modelValue", "options"])])]), _createVNode(_component_app_select, {
        modelValue: $data.form.region,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.region = $event),
        options: $data.regions,
        validateRule: "region",
        label: "Region",
        required: "",
        class: "next-app-select",
        onChange: $options.onRegionChange
      }, null, 8, ["modelValue", "options", "onChange"]), _createVNode(_component_app_select, {
        modelValue: $data.form.country,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.country = $event),
        options: this.getCountries,
        validateRule: "country",
        label: "Country",
        required: "",
        class: "next-app-select"
      }, null, 8, ["modelValue", "options"])])]),
      _: 1
    }, 8, ["onSubmit"])]),
    _: 1
  }, 8, ["modelValue", "onOk"]);
}